import { Resource } from '@core';
import { mc, StyleProps } from '@styles';
import React, { FC } from 'react';
import BackgroundImg from './assets/background.svg';

interface Props extends StyleProps {
  merchant: Resource;
}

export const PostMerchantBlueThumb: FC<Props> = ({ style = {}, className, merchant }) => {
  const { webImage } = merchant;
  return (
    <div
      className={mc(`w-28 h-28`, 'flex justify-center items-center', 'bg-no-repeat bg-center bg-cover', 'rounded-xl', className)}
      style={{ backgroundImage: `url(${BackgroundImg})`, ...style }}
    >
      {!!webImage && (
        <div
          className={mc('rounded-full', 'w-[80%] h-[80%]', 'bg-white bg-no-repeat bg-center', 'border-8 border-ocean-blue')}
          style={{ backgroundImage: `url(${webImage.url})`, backgroundSize: '80%' }}
        />
      )}
    </div>
  );
};

export type PostMerchantBlueThumbProps = Props;
export default PostMerchantBlueThumb;
